import { useLocation, useParams } from 'react-router-dom';

import { getSessionIdFromRoute } from '../utils/sessionId';

const useSessionId = () => {
  const { sessionId: pathSessionId } = useParams();
  const { search } = useLocation();

  return getSessionIdFromRoute({ pathSessionId, search });
};

export default useSessionId;
